<template>
    <section id="interview-card">
      <div class="card">
        <div v-if="isLoading" class="p-3">
          <HorizontalLinesLoader />
        </div> 
        <div
          v-else
          class="card-header d-flex justify-content-between align-items-center p-2"
        >
          <div class="d-flex">
            <div class="mr-1 card-header__interview-icon">
              <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M23.9907 8.77656L23.991 8.77631C24.3093 8.5226 24.6928 8.36386 25.0973 8.31833C25.5018 8.2728 25.911 8.34233 26.2778 8.51892C26.6445 8.69551 26.954 8.97201 27.1707 9.31663C27.3874 9.66125 27.5024 10.06 27.5026 10.4671V10.4673V16.8673C27.5026 18.6887 25.3996 19.6847 23.9907 18.5581V8.77656ZM23.9907 8.77656L20.8359 11.295V8.66732C20.8359 7.47451 19.8621 6.50065 18.6693 6.50065H8.66927C7.47646 6.50065 6.5026 7.47451 6.5026 8.66732V18.6673C6.5026 19.8601 7.47646 20.834 8.66927 20.834H18.6693C19.8621 20.834 20.8359 19.8601 20.8359 18.6673V16.0396M23.9907 8.77656L20.8359 16.0396M20.8359 16.0396L23.9903 18.5578L20.8359 16.0396ZM0.852604 3.6676V3.66732C0.852604 2.10686 2.11534 0.833984 3.66927 0.833984H30.3359C31.8931 0.833984 33.1693 2.11013 33.1693 3.66732V23.6673C33.1693 25.2245 31.8931 26.5007 30.3359 26.5007H7.0026H6.7955L6.64905 26.6471L0.836609 32.4595L0.852604 3.6676Z" fill="#000" stroke="#000"/>
              </svg>
            </div>
            <div>
              <div class="fs-16 card-header__primary-text fw-500">Interviews</div>
              <div class="fs-14 card-header__secondary-text">
                {{
                  filteredInterviews?.length ? 'You have pending interviews' : 'No pending interviews'
                }}
              </div>
            </div>
          </div>
  
          <div>
            <span
              v-if="filteredInterviews?.length"
              class="card-header__material-icons cursor-pointer d-md-none"
              @click.prevent="showInterview = !showInterview"
            >
              expand_more
            </span>
          </div>
        </div>
        <transition
          name="fade"
          enter-active-class="animate__animated animate__fadeIn animate__delay-2"
          leave-active-class="animate__animated animate__fadeOut animate__delay-2"
          >
          <div v-if="filteredInterviews?.length" v-show="showInterview" class="card-body p-3">
            <div
              v-for="(interview, interviewId) in filteredInterviews"
              class=""
              :class="{'border-bottom mb-3 pb-2': interviewId !== filteredInterviews?.length - 1}"
              :key="interview.id"
              > 
              <div>
                <p class="text-dark-grey-1 fw-500 m-0">{{ interview.job_title }} Role</p>
                <div class="d-flex align-items-center justify-content-between">
                    <p class="text-light-grey-1 mb-0">{{interview.calendar_event_url ? 'Check your email for calendar invite link' : 'Check your email for interview details'}}</p>
                </div>
                <p class="text-light-grey-1 mb-0 fs-13">
                  Interview Date: {{ $moment(interview.due_date).format("hh:mma, Do MMM, YYYY") }}
                </p>
                <a class="text-primary fs-13" target="_blank" style="text-decoration: none;" v-if="interview.calendar_event_url" :href="interview.calendar_event_url">view interview</a>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </section>
  </template>
  
  <script>
  import CandidateModel from '../../../models/CandidateModel'
  import HorizontalLinesLoader from "../../admin/jobs/job-management/applicant-tracking-system/includes/loaders/utility/HorizontalLines.vue"

  export default {
    name: "JobinterviewCard",
    components: {
      HorizontalLinesLoader
    },
    mixins: [
        CandidateModel
    ],
    data() {
      return {
        showInterview: true,
        interviews: [],
        isLoading: false
      }
    },
    mounted() {
        this.getCandidateInterviews()
    },
    computed:{
      // this is to ensure that only interviews that have not passed the due date, would be displayed to the candidate
      filteredInterviews() {
        return this.interviews.filter(item => this.$moment().isSameOrBefore(item.due_date))
      }
    }, 
    methods: {
        getCandidateInterviews() {
          this.isLoading = true
          this.CandidateModel.getCandidateInterviews()
            .then((resp) => {                                    
              const interviews = resp.map(obj => {
                return {
                  due_date: obj.date,
                  job_title: obj.application.job.title,
                  calendar_event_url: obj.calendar_event_url
                }
              })
              this.interviews = interviews
            })
            .finally(() => {
              this.isLoading = false
            })
        }
    }
  }
  </script>
  
  